import { State } from '../store';

export const selectUser = (store: State) => store.auth.user;
export const selectRequestType = (store: State) => store.auth.requestType;
